// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-container {
  height: calc(90vh - (6vh + 88px));
  display: flex;
  flex-direction: column;
}
#main-container .container-table {
  margin-top: 10px;
  overflow: auto !important;
  width: 98%;
  margin-left: 1%;
  margin-right: 1%;
}
#main-container .container-table table {
  width: 100%;
}
#main-container .container-table table mat-header-cell, #main-container .container-table table mat-cell {
  display: inline-grid !important;
  justify-content: center;
}
#main-container .container-table table .mat-row-no-data td {
  text-align: center;
  padding: 30px;
  font-size: 28px;
}

/** Responsive */
@media screen and (max-width: 768px) {
  .container-table table mat-header-cell, .container-table table mat-cell {
    display: inline-grid !important;
    justify-content: center;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/utils/shared/components/generic-table/generic-table.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACR;AACQ;EACI,WAAA;AACZ;AACY;EACI,+BAAA;EACA,uBAAA;AAChB;AAGgB;EACI,kBAAA;EACA,aAAA;EACA,eAAA;AADpB;;AASA,gBAAA;AACA;EAKY;IACI,+BAAA;IACA,uBAAA;IACA,aAAA;EAVd;AACF","sourcesContent":["#main-container {\r\n    height: calc(90vh - (6vh + 88px));\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .container-table {\r\n        margin-top: 10px;\r\n        overflow: auto !important;\r\n        width: 98%;\r\n        margin-left: 1%;\r\n        margin-right: 1%;\r\n    \r\n        table {\r\n            width: 100%;\r\n    \r\n            mat-header-cell, mat-cell {\r\n                display: inline-grid !important;\r\n                justify-content: center;\r\n            }\r\n    \r\n            .mat-row-no-data {\r\n                td {\r\n                    text-align: center;\r\n                    padding: 30px;\r\n                    font-size: 28px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/** Responsive */\r\n@media screen and (max-width: 768px) {\r\n\r\n    .container-table {\r\n    \r\n        table {\r\n            mat-header-cell, mat-cell {\r\n                display: inline-grid !important;\r\n                justify-content: center;\r\n                padding: 10px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
